export enum IconTypes {
  IMAGE = 'IMAGE',
  EMOJI = 'EMOJI',
}

export type Icon = {
  custom?: boolean;
  value: string;
  type: IconTypes;
};

export type ImageIconOption = {
  id: number;
  name: string;
  source: string;
  type: IconTypes;
};
